// Language switcher — FR only active, EN/KR visible but disabled (prototype FR-only)
export default function LangSwitcher({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <div className="inline-flex bg-card border border-border rounded-full overflow-hidden text-sm shadow-sm">
        <span className="px-1.5 py-0.5 bg-primary" aria-current="true" aria-label="Français">🇫🇷</span>
        <span className="px-1.5 py-0.5 border-l border-border opacity-40 cursor-not-allowed" title="Not available in prototype">🇬🇧</span>
        <span className="px-1.5 py-0.5 border-l border-border opacity-40 cursor-not-allowed" title="Not available in prototype">🇷🇪</span>
      </div>
    );
  }
  return (
    <div className="inline-flex bg-card border border-border rounded-lg overflow-hidden text-xs font-medium shadow-sm">
      <span className="px-2 py-1.5 bg-primary text-primary-foreground flex items-center gap-1"><span>🇫🇷</span> FR</span>
      <span className="px-2 py-1.5 flex items-center gap-1 border-l border-border opacity-40 cursor-not-allowed" title="FR only in prototype"><span>🇬🇧</span> EN</span>
      <span className="px-2 py-1.5 flex items-center gap-1 border-l border-border opacity-40 cursor-not-allowed" title="FR only in prototype"><span>🇷🇪</span> KR</span>
    </div>
  );
}
